import styles from '../scss/main.scss'

$(() => {
    var windowsize = $(window).width();


  //menu toggle
    $('.burger-menu, .close, .menu a, .join .button').click(function () {
        $('.menu-wrap').toggleClass('open')
    });

    //menu
    //click anchor to scroll
    $('.menu-wrap a,.button.green').click(function(e) {
        if(this.hash && this.hash.length > 1){
            // e.preventDefault();
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
                || location.hostname == this.hostname) {

                var target = $(this.hash);

                target = target.length ? target : $('[id=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 80
                    }, 1000);
                    return false;
                }
            }
        }
    });


});



// WEBPACK FOOTER //
// ./src/js/main.js